// src/components/shared/Select.js
import React, { useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';

const SelectWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(1)};

  svg {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.2rem;
    color: ${(props) => props.theme.colors.primary};
  }

  select {
    width: 100%;
    padding: 20px;
    padding-left: 45px;  /* Leave space for the icon */
    margin: 10px 0;
    font-size: 16px;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;
    appearance: none;
    &:focus {
      border-color: ${(props) => props.theme.colors.primary};
    }
    
    // background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktY2hldnJvbi1kb3duIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEuNjQ2IDQuNjQ2YS41LjUgMCAwIDEgLjcwOCAwTDggMTAuMjkzbDUuNjQ2LTUuNjQ3YS41LjUgMCAwIDEgLjcwOC43MDhsLTYgNmEuNS41IDAgMCAxLS43MDggMGwtNi02YS41LjUgMCAwIDEgMC0uNzA4eiIvPjwvc3ZnPg==');
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 16px;
  }

  label {
    position: absolute;
    top: 0px;
    left: 45px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;
    pointer-events: none;
  }
`;

const Select = ({ icon, label, children, value, ...props }) => {
  const theme = useTheme();
  const [hasValue, setHasValue] = useState(false);

    useEffect(() => {
      if (value && value.length > 0) {
        setHasValue(true);
      } else {
        setHasValue(false);
      }
    }, [value]);

    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: theme.colors.surface,
        borderColor: state.isFocused ? theme.colors.primary : theme.colors.inputBorder,
        boxShadow: state.isFocused ? `0 0 0 1px ${theme.colors.primary}` : 'none',
        paddingLeft: '45px',
        '&:hover': {
          borderColor: theme.colors.primary,
        },
        color: theme.colors.textPrimary,
      }),
    };

return (
  <SelectWrapper>
    {icon && <span>{icon}</span>} {/* This is where the icon will be rendered */}
    <select value={value || ''} {...props} styles={customStyles}
        classNamePrefix="select">
      {children}
    </select>
    <label className={hasValue ? 'active' : ''}>{label}</label>
  </SelectWrapper>
);
};

export default Select;
